var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.loggedIn)?_c('div',[_c('core-toolbar'),_c('core-drawer')],1):_vm._e(),_c('core-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }